import React from 'react';
type ArtifactViewMainContentSignaturesComponentVersionPackageManagerCocoaPodsProps = {
  component: object;
  version: object;
};
const ArtifactViewMainContentSignaturesComponentVersionPackageManagerCocoaPods: React.SFC<
  ArtifactViewMainContentSignaturesComponentVersionPackageManagerCocoaPodsProps
> = props => {
  let component = props.component,
    version = props.version;
  return (
    <div className="grid">
      <div className="grid__item col-1-1 pl0">Podfile:</div>
      <div className="grid__item col-1-1 pt-- pl0">
        <div className="font-family--code bg-color--black-dark p- color--white phone--font--h7 phone--no-overflow">
          pod '{component.name}', '{version.version}'
        </div>
      </div>

      <div className="grid__item col-1-1 pt- pl0">Install:</div>
      <div className="grid__item col-1-1 pt-- pl0">
        <div className="font-family--code bg-color--black-dark p- color--white phone--font--h7 phone--no-overflow">
          pod install
        </div>
      </div>
    </div>
  );
};
export default ArtifactViewMainContentSignaturesComponentVersionPackageManagerCocoaPods;
